module.exports = __webpack_public_path__ + "img/t_icon_3.53d353c7.svg";